import { createAsyncThunk } from "@reduxjs/toolkit";
import { get, fetchData } from "../../services/apiService";
import { showSnackbar } from "../snackbar/Snackbar.slice";

const GET_ACQUIRER_LIST = "adminFields/getAcquirerList";
const GET_ISO_LIST = "adminFields/getISOList";
const GET_MERCHANT_LIST = "adminFields/getMerchantList";

const ERROR_MESSAGES = {
  "040-ACQUIRER_ID_FORMAT_INCORRECT": "Acquirer ID format incorrect",
  "091-ISO_NOT_EXISTS": "Acquirer ISO not exists",
  "025-ACQUIRER_NOT_FOUND": "Acquirer not found",
};

export const getAcquirerList = createAsyncThunk(
  GET_ACQUIRER_LIST,
  async (payload, { rejectWithValue, dispatch }) => {
    const { token, ...rest } = payload;
    const url = "/acquirer";
    try {
      const params = {
        ...rest,
      };
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const { data, page, page_size, total_pages, total_records } = await get(
        url,
        config
      );

      return {
        acquirerData: data,
        page,
        page_size,
        total_pages,
        total_records,
      };
    } catch (error) {
      console.error("Error fetching enrollment data thunk:", error);
      dispatch(
        showSnackbar({
          message: error.response.data.message,
          severity: "error",
        })
      );
      return rejectWithValue(error.response.data);
    }
  }
);

export const getIsoList = createAsyncThunk(
  GET_ISO_LIST,
  async (payload, { rejectWithValue, dispatch }) => {
    const { token, acquirerData, page, page_size, search } = payload;
    const endpoint = "/list-iso-simple";
    const timestamp = new Date().toISOString();
    try {
      const data = {
        version: "04.09.01",
        acquirerID: acquirerData.acquirerId,
        timeStamp: timestamp,
        page,
        page_size,
        ...(search && { search }),
      };

      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        acquirerName: acquirerData.acquirerName,
        acquirerID: acquirerData.acquirerId,
      };
      const response = await fetchData({ endpoint, data, headers, token });

      return response.data;
    } catch (error) {
      console.log("error en el thunk ====>", error.response.data.detail);
      console.error("Error fetching admin fields iso list data thunk:", error);
      dispatch(
        showSnackbar({
          message:
            ERROR_MESSAGES[error.response.data.detail] ||
            error.response.data.detail,
          severity: "error",
        })
      );
      return rejectWithValue(error.response.data);
    }
  }
);

export const getMerchantList = createAsyncThunk(
  GET_MERCHANT_LIST,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const {
        token,
        acquirerId,
        isoID,
        acquirerName,
        page,
        page_size,
        search,
      } = payload;
      const endpoint = `/merchant-list`;
      const data = {
        version: "04.09.01",
        acquirerID: acquirerId,
        page,
        page_size,
        ...(isoID && { isoID }),
        ...(search && { search }),
      };
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        acquirerName: acquirerName,
        acquirerID: acquirerId,
      };

      const {
        data: {
          merchant,
          reqhashMAC,
          page: pageData,
          page_size: pageSizeData,
          total_pages,
          total_records,
        },
      } = await fetchData({ endpoint, data, headers, token });
      return {
        merchantList: merchant,
        reqhashMAC: reqhashMAC,
        page: pageData,
        page_size: pageSizeData,
        total_pages,
        total_records,
      };
    } catch (error) {
      console.error("Error getting merchant list thunk:", error);
      dispatch(
        showSnackbar({
          message: "Error getting merchant list data",
          severity: "error",
        })
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
